<div class="background-view d-flex justify-content-center align-items-center" id="background">
    <div class="main-div">
        <mat-card class="card-panel"> 
            <mat-card-header>
                <img mat-card-avatar [src]="imgThumbnail || defaultThumbnail" alt="">
                <mat-card-title>{{emp.username}}</mat-card-title>
                <mat-card-subtitle>{{emp.fname}} {{emp.lname}}, Revature {{emp.role}}</mat-card-subtitle>
            </mat-card-header>
            <h3>Current RevaPoints:</h3>
            <h1 class="points">{{emp.currentRevaPoints}}</h1>
            <h3>All Time RevaPoints:</h3>
            <h1 class="points">{{emp.allTimeRevaPoints}}</h1>
        </mat-card>
        <mat-card class="card-panel table-card">
            <mat-card-header>
                <mat-card-title>My Batch Info</mat-card-title>
                <mat-card-subtitle>Batch ID: {{emp.batchId}}</mat-card-subtitle>
            </mat-card-header>
                <table mat-table [dataSource]="dataSource" matSort class="mat-elevation-z8">
                  <!-- Name Column -->
                  <ng-container matColumnDef="fname">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header> Associate Name </th>
                    <td mat-cell *matCellDef="let b"> {{b.fname}} {{b.lname}}</td>
                  </ng-container>
              
                  <!-- Points Column -->
                  <ng-container matColumnDef="currentRevaPoints">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header> Current Points </th>
                    <td mat-cell *matCellDef="let b"> {{b.currentRevaPoints}} </td>
                  </ng-container>
            
                  <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                  <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
                </table>
                <mat-paginator #paginator [pageSize]="5" showFirstLastButtons></mat-paginator>
                <mat-card-footer><a [routerLink]="[ '/associate/batchLeaderboard' ]" routerLinkActive="active" class="nav-link">Batch Leaderboard</a></mat-card-footer>
                
        </mat-card>
        <mat-card class="card-panel">
            <h1>My Prizes</h1>
            <hr>
            <carousel [cellsToShow]="cells">
                <ng-container *ngFor="let p of emp.prizes">
                    <div class="carousel-cell">
                        <mat-card-header>
                            <mat-card-title>{{p.name}}</mat-card-title>
                            <mat-card-subtitle>{{p.description}} </mat-card-subtitle>
                            <p>Cost: {{p.cost}}</p>
                        </mat-card-header>
                        <img mat-card-image [src]="p.imgURL" alt="" onerror="this.src='assets/img/prize.jpg'">
                    </div>
                </ng-container>
            </carousel>
            <mat-card-footer><a [routerLink]="[ '/associate/prize' ]" routerLinkActive="active" class="nav-link">View Prize Page</a></mat-card-footer>  
        </mat-card>
    </div>
</div>
